export default "__VITE_ASSET__CGaytOCd__"